<template>
  <div class="animated fadeIn">
    <div class="my-5">
      <div class="display-4 font-3xl text-center">Please select a sample type.</div>
    </div>
    <b-row v-if="sampleTypes">
      <b-col v-for="(type, index) in sortedSampleTypes" :key="index" sm="12" md="4" class="mb-3" >
        <b-button @click="selectSampleType(type)" variant="dark" block class="py-3 h-100">
          <i :class="['far', 'fa-'+(type.icon() ? type.icon() : 'cube'), 'font-3xl']"></i>
          <span class="pl-2 text-uppercase font-weight-bold d-inline-block position-relative" style="top: -5px;">{{type.name}}</span>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import SubmissionNav from "@/components/submissions/SubmissionNav";
  import SubmissionFooterNav from "@/components/submissions/SubmissionFooterNav";
  import SampleTypeCollection from "../../collections/lab/SampleTypeCollection";

  export default {
    components: {SubmissionNav, SubmissionFooterNav},
    name: 'SubmissionAddStep1',
    props: {
      sampleTypes: {
        type: Object,
        default: () => new SampleTypeCollection()
      },
    },
    data() {
      return {}
    },
    computed: {
      sortedSampleTypes() {
        return this.sampleTypes.models.slice().sort((a, b) => a.name.localeCompare(b.name))
      }
    },
    methods: {
      selectSampleType(type) {
        this.$emit('selectSampleType', type)
      }
    }
  }
</script>
